export default __webpack_public_path__ + "static/media/login-background.d3a1ee30.png";